var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-custom-icon"},[_c('img',{staticClass:"home-custom-icon__svg",attrs:{"src":_vm.logoPath,"alt":"","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }